module.exports = __webpack_public_path__ + "static/media/centro-bazterrica-login.5c403617.svg";